var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "-140 -140 1400 1400",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m950.519 985.681 122.372-122.322c14.887-14.887 14.861-39.234 0-54.096l-13.297-13.271c-14.861-14.887-42.918-20.438-62.295-12.363l-70.043 29.167c-19.428 8.124-43.776-.252-54.096-18.57l-.454-.808c-10.345-18.268-30.984-45.416-45.87-60.303l-113.012-113.87c-14.861-14.861-5.979-23.566 5.324-34.845 11.253-11.278 35.475-28.99 53.768-39.36l300.026-170.539c18.217-10.421 24.525-33.734 13.877-51.901l-34.92-59.596c-10.646-18.142-35.955-28.512-56.266-23.062L515.883 369.43c-20.286 5.475-37.595 4.692-52.48-10.193L273.94 174.365c-55.635-55.635-123.003-64.466-158.176-29.293l-2.876 2.876c-35.122 35.122-26.342 102.516 29.294 158.15l186.687 186.561c14.861 14.836 13.853 35.122 8.402 55.408l-129.462 479.749c-5.476 20.286 4.895 45.618 23.011 56.241l59.621 34.92c18.142 10.647 41.48 4.365 51.901-13.902L512.83 805.049c10.421-18.242 28.133-42.464 39.411-53.718 11.304-11.278 25.282-15.189 40.144-.303l108.57 107.99c14.861 14.887 42.011 35.501 60.303 45.82l.808.505c18.293 10.319 26.67 34.668 18.596 54.096l-29.192 69.992c-8.049 19.428-2.549 47.46 12.338 62.321l13.322 13.297c14.861 14.887 39.159 14.887 54.045 0l122.373-122.347Z",
    transform: "translate(12.999 -19.163)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/Airport.7853801da9146017f8900ca9f6aef1fa.svg";
export { ForwardRef as ReactComponent };